// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__ercpF","choiceBoxes":"toolbarselects_choiceBoxes__2HI0e","simpleField":"toolbarselects_simpleField__1qufq"};